"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FeatureFlagProvider = void 0;
const react_1 = __importStar(require("react"));
const useForceUpdate_1 = __importDefault(require("@restart/hooks/useForceUpdate"));
const FeatureToggle_1 = require("../classes/FeatureToggle");
const feature_flag_context_1 = require("../contexts/feature-flag-context");
const FeatureFlagProvider = ({ features = {}, children, }) => {
    const forceUpdate = (0, useForceUpdate_1.default)();
    (0, react_1.useEffect)(() => {
        const subscription = FeatureToggle_1.featureToggle.subscribe(() => {
            forceUpdate();
        });
        return () => {
            subscription.unsubscribe();
        };
    }, []);
    (0, react_1.useEffect)(() => {
        FeatureToggle_1.featureToggle.addFeatures(features);
    }, [features]);
    const featureFlagContextValue = {
        features: FeatureToggle_1.featureToggle.getFeatures(),
        isEnabled: (name) => FeatureToggle_1.featureToggle.isEnabled(name),
    };
    return (react_1.default.createElement(feature_flag_context_1.FeatureFlagContext.Provider, { value: featureFlagContextValue }, children));
};
exports.FeatureFlagProvider = FeatureFlagProvider;
